import React from "react";
import Banner from "./Banner";
import dynamic from "next/dynamic";
import StrategyKeys from "../TechnologyPage/technologies-new/StrategyKeys";
import Strategies from "./Strategies";
const Overview = dynamic(() => import("./overview"), { ssr: true });
const ServicesAi = dynamic(() => import("./servcies"), { ssr: true });
const Capabilities = dynamic(() => import("./capabilites"), { ssr: true });
const Approach = dynamic(() => import("./approch"), { ssr: true });
const Faq = dynamic(() => import("../Home/Faq"), { ssr: true });
const BuildSection = dynamic(() => import("@/Components/BuildSection"), {
  ssr: true,
});
const RFPForm = dynamic(() => import("../Home/Quote"), { ssr: true });
const HocHead = dynamic(
  () => import("@/Components/HigherOrderComponent/HocHead"),
  { ssr: true },
);
const Process = dynamic(() => import("./process"), { ssr: true });

type AiConsultingProps = {
  blocks?: any;
  parent?: string;
  data?: any;
  seo?: any;
  breadcrumbs?: any;
  isMobile?: boolean | undefined;
  slug?: any;
};

const AiConsulting: React.FC<AiConsultingProps> = ({
  blocks,
  isMobile,
  seo,
  parent,
  breadcrumbs,
  slug,
}) => {
  // Pre-compute isFirst / isLast flags for consecutive "2025-service-overview" blocks.
  // This prevents double padding stacking when two (or more) Overview cards are adjacent.
  const overviewPositionMap = React.useMemo(() => {
    const map: Record<number, { isFirst: boolean; isLast: boolean }> = {};
    if (!blocks) return map;
    blocks.forEach((block: any, i: number) => {
      if (block?.__component === "blocks.2025-service-overview") {
        const prevIsOverview = blocks[i - 1]?.__component === "blocks.2025-service-overview";
        const nextIsOverview = blocks[i + 1]?.__component === "blocks.2025-service-overview";
        map[i] = { isFirst: !prevIsOverview, isLast: !nextIsOverview };
      }
    });
    return map;
  }, [blocks]);

  return (
    <>
      {seo && <HocHead seo={seo} />}
      <div>
        <div className="ai-consulting">
          {blocks?.map((block: any, i: number) => {
            switch (block?.__component) {
              case "blocks.2025-banner-inner":
                return (
                  <Banner
                    key={i}
                    isMobile={isMobile}
                    data={block}
                    parent={parent}
                    breadcrumbs={breadcrumbs}
                  />
                );
              case "blocks.2025-service-overview": {
                const hasOverviewData =
                  block?.title ||
                  block?.description ||
                  block?.image?.data?.attributes?.url;
                const hasServicesData = block?.Cards?.length > 0;
                const { isFirst, isLast } = overviewPositionMap[i] ?? { isFirst: true, isLast: true };
                return (
                  <React.Fragment key={i}>
                    {hasOverviewData && (
                      <Overview
                        data={block}
                        image_position={block?.image_position}
                        isFirst={isFirst}
                        isLast={isLast}
                      />
                    )}
                    {hasServicesData && (
                      <ServicesAi data={block} isMobile={isMobile} />
                    )}
                  </React.Fragment>
                );
              }

              case "blocks.2025-ai-services":
                return <ServicesAi key={i} data={block} isMobile={isMobile} />;

              case "blocks.home-new-development-process":
                return <Process key={i} data={block} />;

              case "blocks.2025-capabilities-spectrum":
                return (
                  <Capabilities
                    key={`${i}-${block?.__component}-${slug}`}
                    data={block}
                    isMobile={isMobile}
                    slug={slug}
                  />
                );
              case "blocks.2025-what-sets-aparts":
                return <Approach key={i} data={block} isMobile={isMobile} />;

              case "blocks.strategies":
                return block?.["key-points"]?.length > 0 ? (
                  <StrategyKeys key={i} data={block} />
                ) : (
                  <Strategies key={i} data={block} isMobile={isMobile} />
                );
              case "blocks.2025-home-fa-qs":
                return <Faq key={i} data={block} />;
              case "shared.2025-action-card":
                return <BuildSection key={i} data={block} />;
              case "blocks.2025-home-rfp":
                return <RFPForm key={i} data={block} />;
              default:
                if (process.env.NODE_ENV !== "production") {
                  console.group("Unknown Strapi Block");
                  console.error(
                    "Unknown block type:",
                    block?.__component || "undefined",
                  );
                  console.log("Block Data:", block);
                  console.log("Index:", i);
                  console.log("Slug:", slug);
                  console.groupEnd();
                }
                return null;
            }
          })}
        </div>
      </div>
    </>
  );
};

export default AiConsulting;
